export default __webpack_public_path__ + "static/media/tab_lecturer2.520ed71f.png";